import React from 'react'
import { UserFollowedYouMetadata } from '../../../types/notifications'
import {
  NotificationRowProps,
  NotificationRowShell,
  UserAvatarCircle
} from './notification-row-shell'

const UserFollowedYouRow = (props: NotificationRowProps) => {
  const meta = props.notification.metadata as Partial<UserFollowedYouMetadata> | undefined
  const profileId = meta?.user_slug || meta?.user_id

  return (
    <NotificationRowShell
      {...props}
      avatar={<UserAvatarCircle src={meta?.user_avatar} />}
      destination={profileId ? `/profile/${profileId}` : undefined}
      highlights={[meta?.user_name]}
    />
  )
}

export default UserFollowedYouRow
